import { useState } from "react";
import ReactCountryFlag from "react-country-flag";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Button, Menu, MenuItem } from "@mui/material";

type LanguageSelectProps = {
  value: string;
  width?: number;
  options: Map<string, string>;
  onChange: (nextLangId: string) => void;
};

function LanguageSelect({ value, width, options, onChange }: Readonly<LanguageSelectProps>) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (nextLangId: LanguageSelectProps["value"]) => {
    onChange(nextLangId);
    handleClose();
  };

  const EndIcon = anchorEl ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;

  const languages = Array.from(options);

  return (
    <>
      <Button
        endIcon={EndIcon}
        variant="outlined"
        onClick={handleClick}
        data-testid="app-language-select-list"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "inherit",
          border: "solid 1px",
          borderColor: "primary.main",
          color: "grey.800",
          typography: "body1",
          fontWeight: "normal",
          textTransform: "capitalize",
        }}
      >
        {options.get(value)}
      </Button>

      <Menu keepMounted anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {languages?.map(([id, label]) => (
          <MenuItem key={id} onClick={() => handleSelect(id)} selected={value === id}>
            {label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export { LanguageSelect };
